
enum SelfDescription {
  DietAndTrainingNeedWork = 'DietAndTraining',
  StruggleConsistency = 'Consistency',
  SlowProgress = 'SlowProgress', 
}

const describeSelfQuestion = {
  name: "describeSelf",
  title: "How would you describe your training and nutrition?",
  description: "This helps us understand your current habits, and how best to help.",
  type: "radiogroup",
  choices: [
    {
      value: SelfDescription.DietAndTrainingNeedWork,
      text: "<div class='icon-button'><div>🐣</div><div>Starting from scratch<br /><span class=\"small-text\">My training and nutrition need work</span></div></div>",
    },
    {
      value: SelfDescription.StruggleConsistency,
      text: "<div class='icon-button'><div>🌤️</div><div>Good habits but inconsistent<br /><span class=\"small-text\">I try to stay healthy, but struggle with routine</span></div></div>",
    },
    {
      value: SelfDescription.SlowProgress,
      text: "<div class='icon-button'><div>🐢</div><div>Stuck despite effort<br /><span class=\"small-text\">I train regularly and eat well, but progress is slow</span></div></div>",
    },
  ],
  isRequired: true,
};

export {
  SelfDescription,
  describeSelfQuestion,
}